import { PeriodContext } from '../../context/PeriodProvider';
import { SavingsClient } from '../../services/SavingsClient';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { Skeleton } from '../ui/Skeleton';
import CountUp from 'react-countup';
import { UserContext } from '../../context/UserProvider';
import { useParams } from 'react-router-dom';
import { Message } from '../ui/Message';
import { buildQueryKey } from '../../lib/utils';

export const Savings = ({ applyCountUp = true }) => {
    const { period } = useContext(PeriodContext);
    const user = useContext(UserContext);
    const { id } = useParams();
    const { data, isPending, isError } = useQuery({
        queryKey: [buildQueryKey('savings', id), period],
        queryFn: () => SavingsClient({ ...user, param: id }).getSavings(period),
    });

    if (isError) {
        return <Message type="error">Er is iets misgegaan bij het ophalen van uw besparingen. Probeer het later nog een keer.</Message>;
    }

    if (!data && !isPending) return <Message type="info">Geen data gevonden.</Message>;

    return (
        <>
            <div className="flex w-2/5 md:w-1/2 items-center justify-center">
                {isPending ? (
                    <Skeleton className="w-24 h-24 md:w-32 md:h-32 rounded-full" />
                ) : (
                    <div className="w-24 h-24 md:w-32 md:h-32 bg-primary rounded-full flex items-center justify-center text-white text-xl md:text-3xl">
                        <CountUp
                            start={applyCountUp ? 0 : data.amount}
                            end={data.amount}
                            duration={1}
                            decimals={2}
                            prefix={data.currencySymbol}
                            delay={0.25}
                        />
                    </div>
                )}
            </div>
            <div className="flex w-3/5 md:w-1/2 flex-col text-sm px-2 md:px-3">
                {isPending ? (
                    <div className="flex flex-col gap-2">
                        <Skeleton className="w-full h-[40px] rounded-sm" />
                        <Skeleton className="w-full h-[40px] rounded-sm" />
                        <Skeleton className="w-full h-[40px] rounded-sm" />
                    </div>
                ) : (
                    <>
                        <p>
                            Dit is het bedrag dat u in dit kwartaal heeft bespaard. Deze besparing is berekend op basis van de brandstofprijs in
                            combinatie met uw gebruik.
                        </p>
                        <div className="absolute top-0 right-0 bottom-0 w-3/5 md:w-1/2 bg-secondary -z-10"></div>
                    </>
                )}
            </div>
        </>
    );
};
